<ng-container *mobxAutorun>
  @if (query.page) {
    <app-ref-list [page]="query.page"
                  [newRefs$]="newRefs$"
                  [insertNewAtTop]="true"
                  [expanded]="true"
                  i18n-emptyMessage emptyMessage="No logs found"></app-ref-list>
  }
</ng-container>
